import { SVGProps } from "react";

const Download = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8.00313 11.9429L3.17748 7.12295L4.34983 5.95635L7.18776 8.8V0H8.8185V8.8L11.6564 5.95635L12.8288 7.12295L8.00313 11.9429ZM0.0632324 16V10.6831H1.69399V14.3635H14.3065V10.6831H15.9373V16H0.0632324Z" />
    </svg>
  );
};

export default Download;
